import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import promiseFinally from 'promise.prototype.finally';
promiseFinally.shim();

import {getConfig} from '../lib/service';
import {saveHomework} from '../lib/homework-saver.js';
import {getAccountInfo} from '../reducers/account-info';
import {getParameterByName} from '../utils/tools';
import {getHomeworkInfo} from '../lib/homework-info';
import log from '../lib/log';
import {
    setSaveState,
    SAVE_STATE_NONE,
    SAVE_STATE_AUTO_SAVE_DONE,
    SAVE_STATE_SAVING,
    SAVE_STATE_AUTO_SAVING,
    SAVE_STATE_AUTO_SAVE_FAIL
} from '../reducers/homework-save';


class AutoProjectSaver extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            upLoadLine: 'qiniu'
        };
        getConfig().then(
            config => {
                this.setState({
                    upLoadLine: config.uploadType
                });
            }
        );
        bindAll(this, [
            'autoSaveHomework'
        ]);
        this.time = 0;
    }

    componentDidMount (){
        this.autoSaveHomework();
    }
    componentWillUnmount (){
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
    autoSaveHomework (){
        // 通过url传入调试时用的时间 方便调试
        const debugDelay = Number(getParameterByName('debugAutoSaveTime'));
        let hideSaveDoneIconDelay = 2 * 1000;
        let delay = 5 * 60 * 1000;
        delay = debugDelay > 0 ? debugDelay : delay;
        hideSaveDoneIconDelay = hideSaveDoneIconDelay >= debugDelay ? 100 : hideSaveDoneIconDelay;
        log.info('自动保存作业启动，自动保存间隔：', delay, '毫秒');
        const clearAutoSaveTimer = () => {
            if (this.timer) {
                clearTimeout(this.timer);
            }
        };

        const saveProcess = () => {
            log.info('开始第', ++this.time, '次自动保存');
            const startTime = Date.now();
            const setupAutoSaveTimer = () => {
                this.timer = setTimeout(saveProcess, delay);
            };
            if (this.props.isLoadingProjectError) {
                log.info('因可能项目加载失败了，中止本次自动保存，等待下一次自动保存');
                clearAutoSaveTimer();
                setupAutoSaveTimer();
                return;
            }
            if (!this.props.accountInfo.isLogin) {
                log.info('因未登录，中止自动保存');
                clearAutoSaveTimer();
                return;
            }
            if (this.props.isSavingNow) {
                log.info('因手动保存或提交作业中，中止本次自动保存进程，等待下一次自动保存');
                clearAutoSaveTimer();
                setupAutoSaveTimer();
                return;
            }
            this.props.updateSaveState(SAVE_STATE_AUTO_SAVING);
            this.props.vm.saveProjectSb3()
                .then(content => saveHomework(content, 'DRAFT', this.state.upLoadLine, null)
                    .then(() => {
                        const homeworkInfo = getHomeworkInfo();
                        const courseId = Number(homeworkInfo.courseId);
                        const unitId = Number(homeworkInfo.unitId);
                        const lessonId = Number(homeworkInfo.lessonId);
                        ht.track('s3_autosave', {
                            context: {
                                courseId: courseId,
                                unitId: unitId,
                                lessonId: lessonId,
                                currentUrl: location.href,
                                stageDisplayMode: localStorage.getItem('stageDisplayMode')
                            }
                        });
                        sa.track('s3_autosave');
                        this.props.updateSaveState(SAVE_STATE_AUTO_SAVE_DONE);
                        log.info('自动保存成功,花费时长:', Date.now() - startTime, '毫秒');
                    })
                    .catch(() => {
                    // 上传失败
                        this.props.updateSaveState(SAVE_STATE_AUTO_SAVE_FAIL);
                        log.info('自动保存失败');
                    }))
                .catch(() => {
                    this.props.updateSaveState(SAVE_STATE_AUTO_SAVE_FAIL);
                    log.info('自动保存失败');
                })
                .finally(() => {
                    setTimeout(() => this.props.updateSaveState(SAVE_STATE_NONE), hideSaveDoneIconDelay);
                    clearAutoSaveTimer();
                    setupAutoSaveTimer();
                });
        };
        this.timer = setTimeout(saveProcess, delay);
    }

    render () {
        return null;
    }
}

AutoProjectSaver.propTypes = {
    accountInfo: PropTypes.shape({
        isLogin: PropTypes.bool
    }),
    isLoadingProjectError: PropTypes.bool,
    isSavingNow: PropTypes.bool,
    updateSaveState: PropTypes.func,
    vm: PropTypes.shape({
        saveProjectSb3: PropTypes.func
    })
};

const mapStateToProps = state => ({
    accountInfo: getAccountInfo(state),
    isSavingNow: state.scratchGui.modals.uploadHomeworkProgress ||
            state.scratchGui.modals.finishHomework ||
            state.scratchGui.homeworkSave.saveState === SAVE_STATE_AUTO_SAVING ||
            state.scratchGui.homeworkSave.saveState === SAVE_STATE_SAVING,
    isLoadingProjectError: state.scratchGui.vm.runtime.targets.filter(target => target.isStage).length === 0,
    vm: state.scratchGui.vm
});

const mapDispatchToProps = dispatch => ({
    updateSaveState: state => dispatch(setSaveState(state))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AutoProjectSaver);
